<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 font-45 colorPrincipal">
            LA EDUCACIÓN<br>
            EXPERIMENTAL<br>
            EN EL ALTIPLANO<br>
            <span class="fontMS300">(1930-1950)</span><br>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio4/la-educacion">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio4/la-educacion">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio4/la-educacion">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img001.jpg">
</section>
<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-justify font-24">
                    DURANTE SIGLOS LA EDUCACIÓN FUE UN PRIVILEGIO PARA UNOS POCOS. INCLUSO CUANDO SE ESTABLECE COMO UN
                    DERECHO PARA TODA LA CIUDADANÍA A COMIENZOS DEL SIGLO XX, EN MUCHAS ZONAS DEL PAÍS SIGUEN FALTANDO
                    ESCUELAS, DOCENTES Y UN CURRÍCULO INCLUSIVO QUE REFLEJE LA DIVERSIDAD LINGÜÍSTICA Y CULTURAL DEL
                    PAÍS.
                </p>
                <p class="fontMS100 text-justify font-24">
                    En el Altiplano del Perú se hace frente a este dilema. Las comunidades indígenas hacen peticiones al
                    gobierno para solicitar maestros y, cuando no hay respuesta, surgen diversos proyectos comunitarios:
                    campañas de salud, programas de alfabetización, capacitación vocacional. La educación se convierte
                    en una herramienta para hacer frente a los abusos de los hacendados. Hay resistencia a estas
                    iniciativas, a veces represión violenta, pero los maestros, los estudiantes y las comunidades
                    persisten y durante la primera mitad del siglo XX se logra forjar una tradición de innovación
                    pedagógica en el Altiplano. La escuela se torna un laboratorio para abordar las necesidades de
                    la comunidad y el desarrollo personal del estudiante. También se implementa una metodología bilingüe
                    que busca preservar las tradiciones y saberes locales. En este sentido, los maestros puneños son
                    pioneros de lo que se conoce en la actualidad como la Educación Intercultural Bilingüe.

                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco_L">
    <div class="container">
        <div class="col-sm-12">
            <p>
                <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
            </p>
        </div>
    </div>
</div>
<div class="fondoBlanco_PR">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio4\ET03_MS07_EDU_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS300 text-center colorPrincipal font-40">
                            LA COLECCIÓN <br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio4\ET03_MS07_EDU_LINEA1-recortada.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    PAUL RIVET
                </p>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 5%;margin-bottom:10%;" width="100%"
                        src="\assets\images\micrositio\micrositio4\ET03_MS07_EDU_LINEA1-recortada2.png">
                </div>
                <div class="row">
                    <div class="col-sm-5">
                        <p class="fontMS500 font-24 p2">
                            LA BIBLIOTECA NACIONAL ADQUIERE LA COLECCIÓN DEL RECONOCIDO ETNÓLOGO Y AMERICANISTA FRANCÉS
                            PAUL RIVET EN 1957. CONTIENE MÁS DE MIL DOCUMENTOS RELACIONADOS CON EL ESTUDIO DEL QUECHUA,
                            EL AYMARA Y LAS CULTURAS INDÍGENAS.
                        </p>
                    </div>
                    <div class="col-sm-7">
                        <p class="text-justify fontMS100 font-24 p2_1">
                            Esta amplia colección incluye gramáticas y catecismos del periodo virreinal,
                            libros bilingües y trilingües que hoy forman parte del patrimonio cultural del mundo.
                            También hay partituras, cartillas pedagógicas, poesía, obras de teatro y novelas,
                            estudios lingüísticos, históricos y arqueológicos. Estos documentos manifiestan la
                            reivindicación de las culturas indígenas desde el arte, la literatura y las ciencias
                            sociales en el siglo XX. Nos invitan a reflexionar sobre la identidad nacional,
                            resaltan desafíos y tensiones que siguen vigentes para nuestro país pluricultural
                            y plurilingüe.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris_PR">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-5">
                <p class="imgPaulRivet text-right">
                    <img class="imgNP" width="70%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img002.jpg">
                    <br>
                    <span class="fontMS100Italic t5">Fuente: Biblioteca Nacional Digital de Chile</span>
                </p>
            </div>
            <div class="col-sm-7">
                <p style="line-height: 100%;" class="fontMS300 font-24">
                    <span class="font-40 fontMS500">PAUL RIVET</span><br> (Francia, 1876-1959)
                </p>
                <p class="font-24 text-gris text-justify">
                    <br>
                    Llega a Sudamérica por primera vez en 1901 como parte de la Segunda Misión Geodésica. Durante varios
                    años documenta la historia natural de Ecuador y termina rechazando las prácticas imperantes de la
                    antropología en ese momento. En lugar de medir y clasificar a los seres humanos, Rivet promueve la
                    etnología como una manera de apreciar la igualdad de las sociedades. Dedica los últimos años de su
                    vida al estudio de la diversidad lingüística en la región andina. Antes de fallecer traslada parte
                    de su colección a la Biblioteca Nacional del Perú.
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoGrisD">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio4\ET03_MS07_EDU_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            EDUCADORES PUNEÑOS <br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio4\ET03_MS07_EDU_LINEA1-recortada2.png">
                    </div>
                </div>
            </div>
            <p class=" fontMS500 text-white text-center font-24 mt-5 mb-5">
                A COMIENZOS DEL SIGLO XX, LOS PROYECTOS EDUCATIVOS EN EL ALTIPLANO SON REPRIMIDOS POR LAS AUTORIDADES
                LOCALES POR FOMENTAR EL USO DE LENGUAS INDÍGENAS. ESTE HECHO NO DETIENE A LOS MAESTROS.
            </p>
            <p class="fontMS100 text-white text-justify font-24 mb-5">
                Uno de los precursores de la educación indígena en Puno es Manuel Zúñiga Camacho. Él enfrenta la
                destrucción de la escuela rural de Utawilaya e incluso el encarcelamiento, pero rehace su escuela y,
                con el apoyo de misioneros adventistas, expande el acceso a la educación en la región. En las
                décadas siguientes surgen diversos proyectos comunitarios dedicados a la salud, la alfabetización y
                la capacitación vocacional.
                <br><br>
                Los maestros a continuación conocían bien esta tradición regional y también las innovaciones
                pedagógicas que provenían de Europa y Norteamérica. Optaron por construir sus proyectos a partir de
                la sabiduría local y las necesidades de las comunidades. Tuvieron un impacto innegable en su región
                y en la historia de la educación del país.
            </p>
            <div class="row">
                <div class="col-sm-12 mb-5">
                    <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
                </div>
                <div class="col-sm-4">
                    <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img003a.jpg" alt="" width="100%">
                    <p class="fontMS100Italic txtFuenteImg text-white">
                        Fuente: Encinas, maestro del Perú profundo. Danilo Sánchez Lihón, 1999.
                    </p>
                </div>
                <div class="col-sm-8">
                    <p class="fontMS100 text-white text-justify font-24">
                        <span class="fontMS500">José Antonio Encinas (1886-1958)</span> renueva la educación
                        peruana mediante la “Escuela Nueva”, que propone la relación del estudiante con su
                        entorno social en un ambiente de libertad, tolerancia y comprensión. Al graduarse
                        de la Escuela Normal de Lima en 1906, dirige el Centro Escolar N° 881 de Puno donde
                        ensaya esta metodología. Encinas marca profundamente a las futuras generaciones de
                        maestros e intelectuales en Puno y a nivel nacional.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mb-5">
                    <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
                </div>
                <div class="col-sm-4">
                    <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img003b.jpg" alt="" width="100%">
                    <p class="fontMS100Italic txtFuenteImg text-white ">
                        Fuente: Innata vocación del escritor Gamaliel Churata.
                        José Luis Ayala, 2017.
                    </p>
                </div>
                <div class="col-sm-8">
                    <p class="fontMS100 text-white text-justify font-24">
                        <span class="fontMS500">El Grupo Orkopata se funda en 1925</span> en Puno. A través de
                        la revista el <span class="fontMS100Italic">Boletín Titikaka</span> denuncia la opresión
                        del pueblo indígena y expone una estética vanguardista e indoamericana. En su segunda
                        etapa, los proyectos sociales cobran más importancia. Francisco Chukiwanka propone una
                        ortografía fonética que sirve tanto para la experimentación literaria como para la
                        alfabetización, mientras Emilio Vásquez y Julián Palacios escriben sobre sus
                        experiencias con la educación rural.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mb-5">
                    <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
                </div>
                <div class="col-sm-4">
                    <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img003c.jpg" alt="" width="100%">
                    <p class="fontMS100Italic txtFuenteImg text-white ">
                        Maestros puneños, entre ellos José Portugal Catacora, Alberto Paniagua y Julián
                        Palacios. Archivo José Portugal Catacora.
                    </p>
                </div>
                <div class="col-sm-8">
                    <p class="fontMS100 text-white text-justify font-24">
                        <span class="fontMS500">Julián Palacios Ríos (1887-1976).</span> Como docente reivindica
                        la organización social del ayllu y muestra un respeto profundo por el niño indígena. Es
                        docente en varias instituciones regionales, como la sección normal del Colegio San
                        Carlos, la Academia de Quechua y Aymara de Puno y las Brigadas de Culturización
                        Indígena. Entre 1942 y 1947, fue subdirector nacional de Educación Indígena, como tal
                        ayuda a diseñar e implementar los Núcleos Escolares Campesinos.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mb-5">
                    <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
                </div>
                <div class="col-sm-4">
                    <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img003e.jpg" alt="" width="100%">
                    <p class="fontMS100Italic txtFuenteImg text-white">
                        Anselmo Molleapasa con estudiantes del colegio San Carlos de Puno. Archivo José Portugal
                        Catacora.
                    </p>
                </div>
                <div class="col-sm-8">
                    <p class="fontMS100 text-white text-justify font-24">
                        <span class="fontMS500">En 1935, Julián Palacios, María Asunción Galindo, Francisco Deza
                            y Anselmo Molleapasa</span> fundan la Academia de Quechua y Aymara de Puno. A partir
                        de esta experiencia implementan la Primera Brigada Culturización en la que desarrollan
                        la enseñanza en castellano, quechua y aymara.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mb-5">
                    <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
                </div>
                <div class="col-sm-4">
                    <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img003d.jpg" alt="" width="100%">
                    <p class="fontMS100Italic txtFuenteImg text-white">
                        María Asunción Galindo, Francisco Deza Galindo, Luz de Deza, Julián Palacios y José
                        Portugal Catacora. Archivo José Portugal Catacora.
                    </p>
                </div>
                <div class="col-sm-8">
                    <p class="fontMS100 text-white text-justify font-24">
                        <span class="fontMS500">María Asunción Galindo (1895-1951)</span> es pionera del
                        método bilingüe en el Perú, autora de una cartilla en español y aymara para el nivel
                        inicial. Desarrolla la alfabetización progresiva, tomando en cuenta la vida cotidiana y
                        el bienestar del estudiante. A partir de su experiencia en la Primera Brigada de
                        Culturización funda una escuela comunal para trabajar de manera constante con la
                        comunidad de Ojherani.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mb-5">
                    <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
                </div>
                <div class="col-sm-4">
                    <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img003f.jpg" alt="" width="100%">
                    <p class="fontMS100Italic txtFuenteImg text-white">
                        José Portugal Catacora, foto de Víctor Chambi. Archivo José Portugal Catacora.
                    </p>
                </div>
                <div class="col-sm-8">
                    <p class="fontMS100 text-white text-justify font-24">
                        <span class="fontMS500">José Portugal Catacora (1911-1998).</span> Maestro y autor
                        de ensayos pedagógicos, literatura infantil y libros de folklore. En 1945, participa en
                        la Convención de Warisata, donde elabora el plan para los núcleos escolares campesinos.
                        También participa en la capacitación de profesores peruanos y bolivianos de estos
                        núcleos. En 1948, funda el Instituto de Experimentación Educacional en la ciudad de
                        Puno.
                    </p>
                </div>
                <div class="col-sm-12 mb-5">
                    <p><br></p>
                    <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <p style="line-height: 180%;margin-bottom: 0%;" class="fontMS700 colorPrincipal font-40">
                            LA ESPERANZA DEL PERÚ <br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <img class="LineSubsec_Izq" width="100%"
                            src="\assets\images\micrositio\micrositio4\ET03_MS07_EDU_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="font-24 fontMS500 text-white">
                    <br><br>
                    INSPIRADAS EN LAS MISIONES CULTURALES DE MÉXICO, LAS BRIGADAS DE CULTURIZACIÓN SE FUNDAN EN EL PERÚ
                    EN 1939 CON LA INTENCIÓN DE INTEGRAR A LA POBLACIÓN INDÍGENA A LA NACIÓN.
                    <br> <br>
                </p>
                <div class="row">
                    <div class="col-sm-5">
                        <p class="text-white font-24">
                            Un grupo de docentes puneños, los miembros de La Academia de Aymara y Quechua, reciben el
                            encargo de desarrollar la metodología. Con un altavoz, un camión, un conductor y tres
                            docentes, las Brigadas empiezan su labor en el campo de Puno. Después la iniciativa se
                            extenderá a Cusco, Junín, Áncash y Cajamarca.
                            <br><br>
                            Los brigadistas viajan de pueblo en pueblo para ofrecer charlas en
                            quechua o aymara sobre educación cívica, geografía, historia, salud, economía, agricultura y
                            artesanía. También enfatizan los aportes de las culturas indígenas a la humanidad. Destacan
                            prácticas milenarias en agricultura, ganadería, cultura y construcción. Este amplio
                            currículo tiene como objetivo formar a un nuevo indio que será la esperanza del país.
                        </p>
                    </div>
                    <div class="col-sm-7">
                        <div class="row">
                            <div class="col-sm-6">
                                <p class="text-white font-24">
                                    <span class="fontMS500">Julián Palacios Ríos.</span><br>
                                    <span class="fontMS100Italic">Cancionero andino: para niños indios. </span><br>
                                    Tipografía “Pututo”, 1932.
                                </p>
                            </div>
                            <div class="col-sm-6">
                                <a href="http://hdl.handle.net/20.500.14428/79187" target="_blank" style="color: black;">
                                    <img width="100%"
                                        src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img004a.jpg">
                                </a>
                            </div>
                        </div>
                        <br><br>
                        <div class="row">
                            <div class="col-sm-6">
                                <p class="text-white font-24">
                                    <span class="fontMS500">Ministerio de Instrucción Pública.</span><br>
                                    <span class="fontMS100Italic">La escritura del alfabeto de las lenguas aborígenes
                                        del Perú.</span><br>
                                    Imprenta Americana, 1932.
                                </p>
                            </div>
                            <div class="col-sm-6">
                                <a href="https://hdl.handle.net/20.500.14428/42527" target="_blank" style="color: black;">
                                    <img width="100%"
                                        src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img004b.jpg">
                                </a>
                            </div>
                        </div>
                        <br><br>
                        <div class="row">
                            <div class="col-sm-6">
                                <p class="text-white font-24">
                                    <span class="fontMS500">Primera Brigada de Culturización Indígena. </span><br>
                                    <span class="fontMS100Italic">Cartilla de divulgación del alfabeto quechua-aimara.
                                    </span><br>
                                    Tipografía L. Camacho A, 1932.
                                </p>
                            </div>
                            <div class="col-sm-6">
                                <a href="https://hdl.handle.net/20.500.14428/58051" target="_blank" style="color: black;">

                                    <img width="100%"
                                        src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img004c.jpg">
                                </a>
                            </div>
                        </div>
                        <br><br>
                        <div class="row">

                            <div class="col-sm-6">
                                <p class="text-white font-24">
                                    <span class="fontMS500">Juan Francisco Deza & Anselmo Molleapasa Coello. </span><br>
                                    <span class="fontMS100Italic">Vocabulario trilingüe castellano, quechua i aimara.
                                    </span><br>
                                    Tipografía L. Camacho A, 1945.
                                </p>
                            </div>
                            <div class="col-sm-6">
                                <a href="http://hdl.handle.net/20.500.14428/79184" target="_blank" style="color: black;">

                                    <img width="100%"
                                        src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img004d.jpg">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p>
                    <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" width="100%">
                    <br>
                </p>
                <div class="row">
                    <div class="col-sm-4">
                        <p class="fontMS300 font-20">
                            <br>
                            <span class="fontMS700 font-24">ALEGRÍA</span> <br>
                            NUESTRO MAESTRO YA HA LLEGADO, NOS HA TRAÍDO LA ALEGRÍA: PARA APRENDER MUCHAS COSAS LA
                            ESCUELA SE HA INICIADO, SE HA INICIADO LA ALEGRÍA.
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="fontMS300 font-20">
                            <br>
                            <span class="fontMS700 font-24">KUSISIÑA</span> <br>
                            MAESTROSAJJA PURINIWAY,<br> JIHCHAHJJ KUSISIÑASAWAY: <br>TAQE KUNA YATIÑATAKI
                            <br>ESKWELAJJ
                            JIHSTTARASIWAY, <br>JIHCHAHJJ KUSISIÑASAWAY.
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <p class="fontMS300 font-20">
                            <br>
                            <span class="fontMS700 font-24">KUSIKUY</span> <br>
                            MAESTRUNCHIQA CHAYAMUNÑA, KUNANQ KUSIKUNANCHISMI: IMAYMANATA YACHANANCHISPAJJ ESKWELAQA
                            KICHAKUNÑA <br>KUNANQ KUSIKUNANCHISMI.
                        </p>
                    </div>
                </div>
                <div class="text-right">
                    <p class="fontMS500Italic font-20">
                        <br>
                        CANCIONERO ANDINO: PARA NIÑOS INDIOS, 1932.
                    </p>
                </div>
                <p>
                    <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png"
                        class="reflejo" width="100%">
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoWhiteStar">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio4\ET03_MS07_EDU_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            ENSEÑANZA BILINGÜE <br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio4\ET03_MS07_EDU_LINEA1-recortada2.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    Y ORGANIZACIÓN SOCIAL
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio4\ET03_MS07_EDU_LINEA1-recortada2.png">
                </div>
                <p class="fontMS500 font-24 text-center">
                    <br>
                    PARA LA GRAN MAYORÍA, LA ENSEÑANZA BILINGÜE SE REDUCÍA A UN PASO NECESARIO PARA LOGRAR LA IMPOSICIÓN
                    DEL CASTELLANO COMO ÚNICO IDIOMA NACIONAL. LA PERSPECTIVA DE LOS MAESTROS PUNEÑOS ES OTRA. PROPONEN
                    UNA METODOLOGÍA QUE VALORA LOS DOS IDIOMAS, SIN IMPONER UNO SOBRE OTRO.
                </p>
                <p class="font-24 text-gris text-justify">
                    <br>
                    Demuestran la eficacia de este método a través de escuelas experimentales. La escuela de Ojherani
                    dirigida por María Asunción Galindo es pionera en este sentido. Ella desarrolla materiales
                    (abecedarios, actividades, textos) en base a las experiencias cotidianas de sus estudiantes. La
                    escuela además cuenta con un huerto, un comedor comunal y talleres de artesanía, costura, baile y
                    deporte. Estas iniciativas locales del Altiplano, tanto del Perú como de Bolivia, poco a poco van
                    ganando reconocimiento. Las escuelas reciben visitas internacionales y, en 1945, se celebra una
                    convención binacional de educadores que tiene como resultado la implementación de una red de núcleos
                    escolares campesinos en los dos países.
                    <br><br>
                </p>

                <!--CEL-->
                <div class="row menuWebPhone">
                    <div class="col-sm-3 mb-3">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/40956" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img005a.jpg"
                                    class="p2_cel" width="100%">
                                <div class="overlay">
                                    <p style="font-size: 0.9rem;" class="fontMS500 text-center">
                                        M. Asunción Galindo.
                                        Cartilla de lectura i escritura inicial para los niños de la región aimara,
                                        1947.<br>
                                        <span class="fontMS100 text-center">
                                            Puno: Escuela de Experimentación Educacional de Ojherani.

                                        </span>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 mb-3">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/58266" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img005e.jpg"
                                    class="p2_cel" width="100%">
                                <div class="overlay">
                                    <p style="font-size: 0.9rem;" class="fontMS500 text-center">
                                        Elena Townsend & Guillermo Townsend.
                                        <span class="fontMS100Italic">
                                            Yateqañani = Aprendamos: Sección I.
                                        </span>
                                        <br>
                                        <span class="fontMS100 text-center">
                                            SECPANE/Ministerio de Educación Pública, 1946.
                                        </span>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 mb-3">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/58264" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img005g.jpg"
                                    class="p2_cel" width="100%">
                                <div class="overlay">
                                    <p style="font-size: 0.9rem;" class="fontMS500 text-center">
                                        Elena Townsend & Guillermo Townsend.
                                        <span class="fontMS100Italic">
                                            Yateqañani = Aprendamos: Sección II.
                                        </span>
                                        <br>
                                        <span class="fontMS100 text-center">
                                            SECPANE/Ministerio de Educación Pública, 1946.
                                        </span>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-3 mb-3">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/58274" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img005gh.jpg"
                                    class="p2_cel" width="100%">
                                <div class="overlay">
                                    <p style="font-size: 0.9rem;" class="fontMS500 text-center">
                                        Yachasunchis = aprendamos: primer libro de lectura Sección I preparado para
                                        las
                                        regiones de Puno y Cusco, 1947. <br>
                                        <span class="fontMS100 text-center">
                                            Lima: SECPANE, Ministerio de Educación.
                                        </span>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-3 mt-3">
                        <div class="libro">
                            <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img005b.jpg" class="p2_cel"
                                width="100%">
                            <div class="overlay">
                                <p class="fontMS500 text-center">
                                    Maestros, maestras y visitantes internacionales en Ojherani. <br>
                                    <span class="fontMS100 text-center">
                                        Archivo personal de José Portugal Catacora.
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3 mt-3">
                        <div class="libro">
                            <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img005c.jpg" class="p2_cel"
                                width="100%">
                            <div class="overlay">
                                <p class="fontMS500 text-center">
                                    Estudiantes de la escuela-ayllu de Warisata.<br>
                                    <span class="fontMS100 text-center">
                                        De Gesta y fotografía, de Carlos Salazar Mostajo.
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-3 mt-3">
                        <div class="libro">
                            <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img005d.jpg" class="p2_cel"
                                width="100%">
                            <div class="overlay">
                                <p class="fontMS500 text-center">
                                    El núcleo escolar campesino de Ccota. <br>
                                    <span class="fontMS100 text-center">
                                        Portal Ande.
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3 mt-3">
                        <div class="libro">
                            <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img005f.jpg" class="p2_cel"
                                width="100%">
                            <div class="overlay">
                                <p class="fontMS500 text-center">
                                    Anniversario del Instituto de Experimentación Educacional de Puno. <br>
                                    <span class="fontMS100 text-center">
                                        Archivo personal de José Portugal Catacora.<br>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab3">
                            <a href="https://hdl.handle.net/20.500.14428/40956" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img005a.jpg" width="100%">
                                <div class="overlay">
                                    <p style="font-size: 0.9rem;" class="fontMS500 text-center">
                                        M. Asunción Galindo.
                                        Cartilla de lectura i escritura inicial para los niños de la región aimara,
                                        1947.<br>
                                        <span class="fontMS100 text-center">
                                            Puno: Escuela de Experimentación Educacional de Ojherani.

                                        </span>
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab3">
                            <a href="https://hdl.handle.net/20.500.14428/58266" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img005e.jpg" width="100%">
                                <div class="overlay">
                                    <p style="font-size: 0.9rem;" class="fontMS500 text-center">
                                        Elena Townsend & Guillermo Townsend.
                                        <span class="fontMS100Italic">
                                            Yateqañani = Aprendamos: Sección I.
                                        </span>
                                        <br>
                                        <span class="fontMS100 text-center">
                                            SECPANE/Ministerio de Educación Pública, 1946.
                                        </span>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab3">
                            <a href="https://hdl.handle.net/20.500.14428/58264" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img005g.jpg" width="100%">
                                <div class="overlay">
                                    <p style="font-size: 0.9rem;" class="fontMS500 text-center">
                                        Elena Townsend & Guillermo Townsend.
                                        <span class="fontMS100Italic">
                                            Yateqañani = Aprendamos: Sección II.
                                        </span>
                                        <br>
                                        <span class="fontMS100 text-center">
                                            SECPANE/Ministerio de Educación Pública, 1946.
                                        </span>
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro tab3">
                            <a href="https://hdl.handle.net/20.500.14428/58274" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img005gh.jpg"
                                    width="100%">
                                <div class="overlay">
                                    <p style="font-size: 0.9rem;" class="fontMS500 text-center">
                                        Yachasunchis = aprendamos: primer libro de lectura Sección I preparado para las
                                        regiones de Puno y Cusco, 1947. <br>
                                        <span class="fontMS100 text-center">
                                            Lima: SECPANE, Ministerio de Educación.
                                        </span>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab3">
                            <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img005b.jpg" width="100%">
                            <div class="overlay">
                                <p class="fontMS500 text-center">
                                    Maestros, maestras y visitantes internacionales en Ojherani. <br>
                                    <span class="fontMS100 text-center">
                                        Archivo personal de José Portugal Catacora.
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div class="col-sm-6 libro tab3">
                            <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img005c.jpg" width="100%">
                            <div class="overlay">
                                <p class="fontMS500 text-center">
                                    Estudiantes de la escuela-ayllu de Warisata.<br>
                                    <span class="fontMS100 text-center">
                                        De Gesta y fotografía, de Carlos Salazar Mostajo.
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro tab3">
                            <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img005d.jpg" width="100%">
                            <div class="overlay">
                                <p class="fontMS500 text-center">
                                    El núcleo escolar campesino de Ccota. <br>
                                    <span class="fontMS100 text-center">
                                        Portal Ande.
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div class="col-sm-6 libro tab3">
                            <img src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_img005f.jpg" width="100%">
                            <div class="overlay">
                                <p class="fontMS500 text-center">
                                    Anniversario del Instituto de Experimentación Educacional de Puno. <br>
                                    <span class="fontMS100 text-center">
                                        Archivo personal de José Portugal Catacora.<br>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="\assets\images\micrositio\micrositio4\ET03_MS07_EDU_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            HACIA UNA EDUCACIÓN <br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width=" 100%"
                            src="\assets\images\micrositio\micrositio4\ET03_MS07_EDU_LINEA1-recortada2.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    INTERCULTURAL
                </p>
                <div class="c100">
                    <img class="lineCel" style="margin-top: 5%;" width="100%"
                        src="\assets\images\micrositio\micrositio4\ET03_MS07_EDU_LINEA1-recortada2.png">
                </div>
                <p class="text-center font-24 fontMS500">
                    <br>
                    ENTRE 1945 Y 1948 EL MINISTERIO DE EDUCACIÓN DA MAYOR RESPALDO A LA EDUCACIÓN RURAL BILINGÜE Y, AL
                    MISMO TIEMPO, EMPRENDE LA MISIÓN DE DOCUMENTAR LA GRAN DIVERSIDAD CULTURAL DEL PAÍS.
                    <br><br>
                </p>
                <p class="font-24 text-justify">
                    Bajo el liderazgo del ministro Luis Eduardo Valcárcel, la Dirección de Educación Artística y
                    Extensión
                    Cultural asume el reto de recopilar el folklore de todas partes del país con el objeto de elaborar
                    material pedagógico y construir un imaginario nacional más inclusivo.
                    <br><br>
                    A través de la Colección Escolar Peruana, las historias, cuentos y leyendas locales trascienden sus
                    lugares de origen para ser leídos en todo el país. Con<span class="fontMS100Italic"> Rutsí: el
                        pequeño alucinado</span>, la celebrada
                    autora e ilustradora Carlota Carvallo cuenta las aventuras de un pequeño espíritu de la selva
                    peruana. También se destaca la histórica iniciativa de José María Arguedas y Francisco Izquierdo
                    Ríos, quienes idearon un proyecto de recopilación de folklore liderado por los maestros rurales.
                    <span class="fontMS100Italic">Mitos, leyendas y cuentos peruanos</span> es el resultado de este
                    trabajo colectivo. Durante este período
                    relativamente breve, aparecen publicaciones similares en toda la región. Los educadores peruanos,
                    bolivianos y ecuatorianos buscan recopilar y sistematizar el folklore para fines pedagógicos.

                    <br>
                </p>
            </div>
        </div>
    </div>
    <div class="w-90 text-center ml-auto mr-auto">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let slide of slides2" class="slide p-2">
                <!-- <a style="color: inherit;" target="_blank" [routerLink]="['/ficha',slide.id]"> -->
                <a style="color: inherit;" target="_blank" href="{{slide.id}}">
                    <div class="divLibros text-center w-100">
                        <p class="text-center">
                            <img src="{{ slide.img }}" alt="" width="100%">
                        </p>
                        <div class="divNombresLibros">
                            <p class="text-center">
                                <span>{{slide.autor}}</span><br>
                                <span>{{slide.anno}}</span>
                            </p>
                        </div>
                    </div>
                </a>
            </div>
        </ngx-slick-carousel>
    </div>
</div>
<div class="fondoOrange">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="text-white fontMS500 font-24">
                            Los educadores puneños fueron precursores de lo que se conoce en la actualidad como la
                            educación intercultural bilingüe (EIB). La EIB se basa en el respeto por la identidad
                            cultural y lingüística de los estudiantes y promueve la construcción de una sociedad libre
                            de discriminación.
                        </p>
                    </div>
                    <div class="col-sm-12 mb-5 mt-4">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            ¿Cuántos idiomas se hablan en nuestro país? ¿Tú hablas o entiendes alguna lengua originaria?
                            ¿Cuáles?
                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            Dibuja un mapa del Perú, señalando el lugar donde naciste y el lugar donde nacieron tus
                            padres, tus abuelos y tus bisabuelos. ¿Qué conoces de estos lugares, qué historias te han
                            contado, cuáles son sus idiomas y costumbres?
                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            Los folletos publicados por la Brigadas de Culturización cantan orgullo y amor por los
                            Andes. También eran instrumentos para educar bajo las ideas de modernización, por ejemplo,
                            sugieren cambios en la vestimenta y las costumbres. Te invitamos a reflexionar sobre estas u
                            otras tensiones culturales que encuentras en los textos.
                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="\assets\images\micrositio\micrositio4\ET03_MS07_EDU_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 80%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="\assets\images\micrositio\micrositio4\ET03_MS07_EDU_LINEA1-recortada2.png">
                    </div>
                </div>
                <p class="font-24">
                    <br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.<br>
                    <br>
                </p>
            </div>
            <div class="col-sm-6">
                <p class="fontMS100Italic font-24">
                    <span class="fontMS500">
                        Zapata, A. (2013).
                    </span>
                    <br>
                    Militarismos y maestros indigenistas:
                    1933-1956.<br>
                    <span class="fontMS100 text-gris">
                        Lima: Fondo Editorial de la
                        Derrama Magisterial.<br>
                    </span>
                    <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=442725" target="_blank"
                        style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="fontMS100Italic font-24">
                    <br>
                    <span class="fontMS500">
                        Contreras, C. y Oliart, P. (2014).
                    </span>
                    <br>
                    Modernidad y Educación en el Perú.
                    <br>
                    <span class="fontMS100 text-gris">
                        Lima: Ministerio de Cultura.
                    </span>
                    <br>
                    <a href="http://repositorio.cultura.gob.pe/handle/CULTURA/31" target="_blank" style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="fontMS100Italic font-24">
                    <br>
                    <span class="fontMS500">
                        Portugal Catacora, J. (2018).
                    </span>
                    <br>
                    Historia de la educación en Puno:
                    experiencias educativas en el Altiplano.

                    <span class="fontMS100 text-gris">
                        Puno: Gobierno Regional de Puno.
                    </span>
                    <br>
                    <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=554464" target="_blank"
                        style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
            </div>
            <div class="col-sm-6">
                <p class="fontMS100Italic font-24">
                    <span class="fontMS500">
                        Ruelas Vargas, D. (2016).
                    </span>
                    <br>
                    La escuela rural indígena de Utawilaya: una
                    educación liberadora desde Puno – Perú.
                    <span class="fontMS100 text-gris">
                        En: Revista Historia de la Educación Latinoamericana 18(27): 243-262.
                    </span>
                    <br>
                    <a href="http://www.scielo.org.co/pdf/rhel/v18n27/v18n27a12.pdf " target="_blank"
                        style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="fontMS100Italic font-24">
                    <br>
                    <span class="fontMS500">
                        Velásquez, J. L. (2007).
                    </span>
                    <br>
                    Movimientos sociales y la escuela en el
                    Altiplano, 1860-1930.

                    <span class="fontMS100 text-gris">Puno: Universidad
                        Nacional del Altiplano.
                    </span>
                    <br>
                    <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=352020" target="_blank"
                        style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="fontMS100Italic font-24">
                    <br>
                    <span class="fontMS500">
                        Vilca Apaza et al. (2018).
                    </span>
                    <br>
                    Maestros indigenistas y sus experiencias
                    socio-educativas en el altiplano peruano en
                    el siglo XX.
                    <span class="fontMS100 text-gris">
                        En: Comuni@cción, 9(2).
                    </span>
                    <br>
                    <a href="http://www.scielo.org.pe/scielo.php?script=sci_arttext&pid=S2219-71682018000200002"
                        target="_blank" style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
            </div>
        </div>
    </div>
</div>
<!-- Footer -->